import React from 'react'

import { Modal } from '@components/common/modal'

interface EditPDFModalProps {
  title?: string
  children?: React.ReactNode
  close: () => void
}

const EditPDFModal: React.FC<EditPDFModalProps> = ({
  title,
  children,
  close,
}) => {
  if (!children) {
    return null
  }

  return (
    <Modal hideModal={close} width="800px" title={title}>
      <div style={{ padding: '20px' }}>{children}</div>
    </Modal>
  )
}

export default EditPDFModal
